import { DatePipeConfig } from '@angular/common';
import { InjectionToken } from '@angular/core';
import { Locale } from 'date-fns';

export interface Language {
  description: string;
  code: string;
}

export interface LocaleConfig {
  id: string;
  description: string;
  angularLocale: unknown;
  dateFnsLocale: Locale;
  freshdeskLocale: string;
  datePlaceholder: string;
  dateMask: string;
}

export interface LocalizationConfig {
  defaultLocale?: string;
  defaultCurrencyCode?: string;
  devMode?: boolean;
  datePipeConfig?: DatePipeConfig;
}

export const LOCALIZATION_CONFIG = new InjectionToken<LocalizationConfig>(
  'Configuration for localization functionality'
);

export const LOCALE_CONFIG = new InjectionToken<LocaleConfig>(
  'Configuration for locale data'
);
